export default {
  subFieldDelimiter: "_",
  emptyValue: "-",
  countryCodePostfix: "country-code",
  cprDelimiter: "-",
  phoneDelimiter: "\\s",
  primitiveProps: [
    "label",
    "validators",
    "conditions",
    "clearButtonAriaLabel",
    "name",
    "autocomplete",
    "description",
    "type",
    "maxLength",
    "predefinedValue",
    "required",
    "allowConstructedCvrNumber",
  ],
  formats: {
    cpr: {
      mask: "000000-0000",
    },
  },
};
